import { useAnalytics } from '@ecosystem/newron-client-lib';
import { useSelector } from 'react-redux';
import { SaleTypeMapping } from '@const/PerformanceType';
import { SaleType } from '@models/OpportunityReview';
import {
  CHART_RADIO_BUTTON_TRACKING_TITLE,
  ChartElementName,
  ChartElementType,
  chartInteractionTrackingFunction,
  ChartInteractionTrackingFunctionParam,
} from '@utils/page-analytics/model/ChartInteractionTracking';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { FactRevenue } from '@utils/pageConfig/Types';
import { constructRevenueTitle } from '@utils/currencyUtils/CurrencyUtils';
import { SelectorType } from '@utils/design/ButtonMenuUtils';
import { WithHiddenListBox } from '@components/design';
import React from 'react';

interface Props {
  selectedSalesType: SaleType;
  onSalesTypeChange: (salesType: SaleType) => void;
  chartName: string;
  factRevenue: FactRevenue;
  volume: string;
  isDisabled: boolean;
}

const OpportunityReviewFilter: React.FC<Props> = ({
  selectedSalesType,
  onSalesTypeChange,
  chartName,
  factRevenue,
  volume,
  isDisabled,
}) => {
  const { track } = useAnalytics();
  const { pageType, pageName, access } = usePageConfig();
  const sideFiltersState = useSelector((state: any) => state.sideFilters);
  const retailerClientState = useSelector((state: any) => state.retailerClient);
  const revenueTitle = constructRevenueTitle(factRevenue);

  // Chart Interaction Tracking Function
  const handleChartInteractionTracking = (salesType: string) => {
    const trackingParam: ChartInteractionTrackingFunctionParam = {
      eventTitle: CHART_RADIO_BUTTON_TRACKING_TITLE,
      sideFilters: sideFiltersState.appliedFilters,
      retailerClientState: retailerClientState,
      track: track,
      pageType,
      pageName,
      elementName: ChartElementName.DISPLAY_BY,
      elementType: ChartElementType.FILTER,
      optionChosen: SaleTypeMapping(volume)[salesType as SaleType],
      chartName,
      access: access,
    };
    chartInteractionTrackingFunction(trackingParam);
  };
  const options = [
    { label: revenueTitle, value: SaleType.VALUE },
    { label: volume, value: SaleType.VOLUME },
  ];

  const kpiValue = selectedSalesType;
  const kpiOptionValue = options.find((o) => o.value === kpiValue)?.label ?? options[0].label;

  const handleSalesTypeChange = (salesType: string) => {
    onSalesTypeChange(salesType as SaleType);
  };

  return (
    <div>
      <div className="flex">
        <div key={SelectorType.KPI} data-testid={'kpi-selector'}>
          <WithHiddenListBox
            isDisabled={isDisabled}
            label="by"
            options={options}
            value={kpiOptionValue}
            onChange={(option) => {
              handleSalesTypeChange(option.value);
              handleChartInteractionTracking(option.value as SaleType);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OpportunityReviewFilter;
